import triangle from "./assets/triangle.png";
import star from "./assets/star.png";

interface CalendarTheme {
  value: string;
  label: string;
  src: string;
  color: string;
}

const themes: CalendarTheme[] = [
  {
    value: "triangle",
    label: "Triangle",
    src: triangle,
    color: "#f44336",
  },
  {
    value: "star",
    label: "Star",
    src: star,
    color: "#ffc107",
  },
];

export default themes;
